//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
//#reg

const GetRefund = (params: any) =>
    request({
        url: ApiURL.Query.getRefund,
        method: RequestType.GET,
        params: params,
    });
const GetRefundListHistory = (params: any) =>
    request({
        url: ApiURL.Query.getRefundListHistory,
        method: RequestType.GET,
        params: params,
    });
const DoRefund = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.doRefund,
        method: RequestType.POST,
        data,
    });
const TryDoRefund = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.tryDoRefund,
        method: RequestType.POST,
        data,
    });

const GetRefundOfReturn = (params: any) =>
    request({
        url: ApiURL.Query.getrefundofreturn,
        method: RequestType.GET,
        params: params,
    });

const GetReturnToSellerListShippingListsForStoreV2 = (params: any) =>
    request({
        url: ApiURL.Query.getreturntosellerlistshippinglistsforstorev2,
        method: RequestType.GET,
        params: params,
    });
const GetDocumentHeaderOfSellerReturnDispatchList = (params: any) =>
    request({
        url: ApiURL.Query.getDocumentHeaderOfSellerReturnDispatchList,
        method: RequestType.GET,
        params: params,
    });
const SearchRefund = (params?: any) =>
    request({
        url: ApiURL.Query.searchRefund,
        method: RequestType.GET,
        params: params,
    });

const ConvertRefundToWalletTransaction = (data: any) =>
    request({
        url: ApiURL.Query.convertRefundToWalletTransaction,
        method: RequestType.POST,
        data: data,
    });

const CreatePetition = (data: any) =>
    request({
        url: ApiURL.Query.createPetition,
        method: RequestType.POST,
        data: data,
    });

const UpdateWireRefundCustomerChoice = (data: any) =>
    request({
        url: ApiURL.Query.updateWireRefundCustomerChoice,
        method: RequestType.POST,
        data: data,
    });

const GetRefundStatusList = () =>
    request({
        url: ApiURL.Query.GetRefundStatusList,
        method: RequestType.GET,
    });

const GetRefundImages = (data: any) =>
    request({
        url: ApiURL.Query.getRefundImages,
        method: RequestType.POST,
        data: data,
    });

const RefundQuery = {
    CreatePetition,
    SearchRefund,
    GetRefund,
    GetRefundImages,
    GetRefundListHistory,
    DoRefund,
    TryDoRefund,
    GetRefundOfReturn,
    GetDocumentHeaderOfSellerReturnDispatchList,
    ConvertRefundToWalletTransaction,
    UpdateWireRefundCustomerChoice,
    GetRefundStatusList,
    GetReturnToSellerListShippingListsForStoreV2,
};

export default RefundQuery;
